

export function formatToChatTime(dateString: string){
        const now = new Date();
        const inputDate = new Date(dateString);

        // Strip time parts for accurate day comparison
        const nowDateOnly = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime()
        const inputDateOnly = new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate()).getTime();

        const diffDays = Math.floor((nowDateOnly - inputDateOnly) / (1000 * 60 * 60 * 24));

        const timeFormatter = new Intl.DateTimeFormat(window.navigator.languages, {
            hour: '2-digit',
            minute: '2-digit',
        });

        const relativeDateFormatter  = new Intl.RelativeTimeFormat(window.navigator.languages, { numeric: 'auto' });

        if (diffDays === 0) {
            // Today
            return timeFormatter.format(inputDate);
        } else if (diffDays === 1) {
            // Yesterday
            return `${relativeDateFormatter.format(-diffDays, 'day')} ${timeFormatter.format(inputDate)}`;
        } else {
            // Older
            const dateFormatter = new Intl.DateTimeFormat(window.navigator.languages, {
                hour: '2-digit',
                minute: '2-digit',
                day: '2-digit',
                month: '2-digit',
                year: '2-digit',
            });
            return dateFormatter.format(inputDate);
        }
}